import { render } from "./NewLiveShop.vue?vue&type=template&id=7dbf6783"
import script from "./NewLiveShop.vue?vue&type=script&lang=js"
export * from "./NewLiveShop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__